(function () {
  'use strict';

  if (window.__VSKLO_PREMIUM_HERO_COUNTER_V1__) return;
  window.__VSKLO_PREMIUM_HERO_COUNTER_V1__ = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function animateCounter(stage) {
    if (stage.dataset.vphCounterReady === 'true') return;
    stage.dataset.vphCounterReady = 'true';

    var end = Math.max(1, parseInt(stage.dataset.vphCounterEnd, 10) || 155);
    var duration = Math.max(0, parseInt(stage.dataset.vphCounterDuration, 10) || 2200);

    function start() {
      if (stage.dataset.vphCounterStarted === 'true') return;
      stage.dataset.vphCounterStarted = 'true';

      if (reduceMotion.matches || duration === 0) {
        stage.dataset.vphCounterValue = end;
        return;
      }

      var startedAt = performance.now();

      var currentValue = 1;

      function frame(now) {
        var progress = Math.min((now - startedAt) / duration, 1);
        var expectedValue = Math.floor(1 + (end - 1) * progress);

        if (expectedValue > currentValue) {
          currentValue += 1;
          stage.dataset.vphCounterValue = currentValue;
        }

        if (currentValue < end) {
          requestAnimationFrame(frame);
        } else {
          stage.dataset.vphCounterValue = end;
        }
      }

      requestAnimationFrame(frame);
    }

    if (!('IntersectionObserver' in window)) {
      start();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      start();
    }, { threshold: 0.15 });

    observer.observe(stage);
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-vph-decorative-counter]').forEach(animateCounter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
}());
